import { Badge } from '@shared/components/ui/badge';
import { useTranslation } from 'react-i18next';
import { ReceptionStatus } from '../../models/Reception';

interface ReceptionStatusBadgeProps {
  status: ReceptionStatus;
}

/**
 * Badge que muestra el estado de una recepción
 */
export const ReceptionStatusBadge: React.FC<ReceptionStatusBadgeProps> = ({ status }) => {
  const { t } = useTranslation('receptionsModule');

  const getVariant = (): 'default' | 'secondary' | 'success' | 'warning' | 'destructive' => {
    switch (status) {
      case 'UNIDENTIFIED':
        return 'warning';
      case 'IDENTIFYING':
        return 'secondary';
      case 'CLOSED':
        return 'success';
      default:
        return 'default';
    }
  };

  const getLabel = (): string => {
    switch (status) {
      case 'UNIDENTIFIED':
        return t('status.unidentified');
      case 'IDENTIFYING':
        return t('status.identifying');
      case 'CLOSED':
        return t('status.closed');
      default:
        return status;
    }
  };

  return (
    <Badge variant={getVariant()} className="whitespace-nowrap">
      {getLabel()}
    </Badge>
  );
};

export default ReceptionStatusBadge;
